let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
  {
    label: "消息标题",
    props: "warnDetailTypeName",
    minWidth: 280,
    align: "center",
    formatter: function (row) {
      const iconClass = getMessageIconClass(row.warnType);
      const title = row.warnDetailTypeName || "-";
      const subtitle = row.content || "";
      // v-html 不编译 Vue 组件，用原生 HTML 模拟 el-tag 样式
      const pushTypeTag = row.warnType == "101" && row.pushType
        ? `<span style="display: inline-block; padding: 0 8px; height: 20px; line-height: 18px; font-size: 12px; border-radius: 4px; background: #f0f9eb; border: 1px solid #c2e7b0; color: #67c23a; margin-right: 8px;">${escapeHtml(row.pushType)}</span>`
        : "";
      const categoryTag = row.categoryName
        ? `<span style="display: inline-block; padding: 0 8px; height: 20px; line-height: 18px; font-size: 12px; border-radius: 4px; background: #f4f4f5; border: 1px solid #e9e9eb; color: #909399;">${escapeHtml(row.categoryName)}</span>`
        : "";
      return `
        <div style="display: flex; align-items: flex-start; gap: 15px;">
          <i class="el-icon-${iconClass}" style="font-size: 20px; color: #409EFF; margin-top: 2px;"></i>
          <div style="text-align: left;">
            <div style="font-weight: 600; margin-bottom: 4px;">${escapeHtml(title)}</div>
            <div style="margin-bottom: 4px;">${pushTypeTag}${categoryTag}</div>
            ${subtitle ? `<div style="font-size: 12px; color: #909399;">${escapeHtml(subtitle)}</div>` : ""}
          </div>
        </div>
      `;
    },
  },
  {
    label: "分类",
    props: "categoryName",
    minWidth: 180,
    align: "center",
    formatter: function (row) {
      const mainCategory = row.warnType == '01' || row.warnType == '02' || row.warnType == '05' ? '充电通知' : row.warnType == '101' ? '活动通知' : '系统通知';
      const subCategory = row.warnTypeName || "";
      return `
        <div>
          <div>${mainCategory}</div>
          ${subCategory ? `<div style="font-size: 12px; color: #909399;">${subCategory}</div>` : ""}
        </div>
      `;
    },
  },
  {
    label: "接收者",
    props: "userPhone",
    minWidth: 140,
    align: "center",
    formatter: function (row) {
      const phone = row.userPhone || "-";
      const masked = formatPhone(phone);
      const hasPhone = phone && phone !== "-" && String(phone).replace(/\D/g, "").length >= 7;
      if (!hasPhone) return masked;
      return `
        <span class="phone-cell-wrap" style="display: inline-flex; align-items: center; gap: 4px;">
          <span class="phone-display">${escapeHtml(masked)}</span>
          <i class="el-icon-view phone-toggle" data-phone="${escapeHtml(phone)}" data-masked="${escapeHtml(masked)}" data-showing="masked" style="cursor: pointer; font-size: 14px; color: #909399;" title="点击切换显示" onclick="typeof window.__togglePhoneDisplay==='function'&&window.__togglePhoneDisplay(this)"></i>
        </span>
      `;
    },
  },
  {
    label: "推送时间",
    props: "createdWhen",
    minWidth: 180,
    align: "center",
    formatter: function (row) {
      const time = row.createdWhen || "-";
      return `<span><i class="el-icon-date" style="margin-right: 4px; color: #909399;"></i>${time}</span>`;
    },
  },
  {
    label: "状态",
    props: "pushStatus",
    minWidth: 120,
    align: "center",
    formatter: function (row) {
      const status = "推送成功";
      return `<span style="color: #67C23A;"><i class="el-icon-success" style="margin-right: 4px;"></i>${status}</span>`;
    },
  },
  {
    label: "阅读状态",
    props: "readStatus",
    minWidth: 120,
    align: "center",
    formatter: function (row) {
      const isRead = row.status === "02";
      const icon = isRead ? "el-icon-view" : "el-icon-time";
      const text = isRead ? "已读" : "未读";
      const color = isRead ? "#409EFF" : "#909399";
      return `<span style="color: ${color};"><i class="${icon}" style="margin-right: 4px;"></i>${text}</span>`;
    },
  },
];

// 手机号脱敏格式化 138****5678
function formatPhone(phone) {
  if (!phone || phone === "-") return "-";
  const str = String(phone).replace(/\D/g, "");
  if (str.length >= 11) return str.slice(0, 3) + "****" + str.slice(-4);
  if (str.length >= 7) return str.slice(0, 3) + "****" + str.slice(-4);
  return phone;
}
// HTML 转义防 XSS
function escapeHtml(str) {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
// 消息分类图标映射 (Element UI 图标名)
function getMessageIconClass(categoryCode) {
  const iconMap = {
    '01': "chat-dot-round", // 充电相关
    '02': "bell", // 充电相关
    '05': "bell", // 充电相关
    '101': "present", // 活动
    '03': "date", // 系统通知
    '12': "bell", // 充电闹钟
  };
  return iconMap[categoryCode] || "bell";
}

// 面包屑
pageConfig.listBreadCrumb = [
  { type: "title", name: "首页" },
  { type: "title", name: "运营配置" },
  { type: "title", name: "消息推送" },
  { type: "title", name: "消息推送记录" },
];

// 列表-表格属性
pageConfig.tableConfig = {
  showSelection: false,
  showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
  current: 1,
  total: 0,
  pageSize: 10,
  pageSizes: [10, 20, 50, 100],
};

export default pageConfig;
